export default "__VITE_ASSET__BjxVgSKu__"